
export const LeadOwnerTeamLeadDashboardPermissions = {
  LeadOwnerTeamLeadDashboard: {
    permissionsId:'d37fe88e-6f3b-4b85-f945-08dc0f48c1d2',
    permissionsName: 'Lead Owner Team Lead Dashboard',
    componentsId:null,
    components:null
  }
  } ;